// @ts-nocheck
import { Injectable } from '@angular/core';
import { MessageFeedTemplate } from 'models/shared.models';

@Injectable({
	providedIn: 'root',
})
export class MessageFeedbackService {
	constructor() {}

	public messageFeedObject: MessageFeedTemplate = {
		primary: '',
		secondary: '',
		emoji: '',
		type: 'danger',
		show: false,
		autoclose: true,
	};

	public setFeedback(
		primary: string,
		secondary: string,
		emoji: string,
		type: 'danger' | 'warning' | 'success',
		autoclose = true,
	): void {
		this.messageFeedObject.primary = primary;
		this.messageFeedObject.secondary = secondary;
		this.messageFeedObject.emoji = emoji;
		this.messageFeedObject.type = type;
		this.messageFeedObject.autoclose = autoclose;
		this.messageFeedObject.show = true;
	}

	public closeFeed(): void {
		this.messageFeedObject.show = false;
	}
}
